<div class="card card-nb h-100">
  <div class="card-body">
    <h2>{{ 'availability_headline' | i18next }}</h2>

    <div class="d-flex flex-column">
      @if (!isOrderAvailability) {
        <div>
          <span [innerHTML]="'availability_active_level_description' | i18next: {current: currentAvailibilty}"></span>
        </div>
      }
      @if (isOrderAvailability) {
        <div>
          <span [innerHTML]="'availabilty_description_changing_level' | i18next: {current: currentAvailibilty, next: nextAvailibility, date: (deliveryDate | localized_date) }"></span>
        </div>
      }

      @if (subscription.isAvailabilityPremium) {
        <div class="d-flex mt-3">
          <i class="fa fa-info-circle red mr-2"></i>
          <span class="subinformations">{{ 'availability_note_premium' | i18next }}</span>
        </div>
      }

      @if (subscription.isAvailabilityStandard) {
        <div class="d-flex mt-3">
          <i class="fa fa-info-circle red mr-2"></i>
          <span class="subinformations">{{ 'availability_note_standard' | i18next }}</span>
        </div>
      }

      <div class="d-flex justify-content-end mt-auto">
        @if (isOrderAvailability) {
          <button
            class="btn btn-link small"
            (click)="cancelOrder()"
          >{{ 'cancel_order_headline' | i18next }}</button>
        }
        <button
          [disabled]="isOrderAvailability"
          class="btn btn-outline-primary"
          (click)="changeAvailability()"
        >{{ 'availability_button_change' | i18next }}</button>
      </div>
    </div>
  </div>
</div>
